export const versionKeys = {
  all: ["versions"] as const,
  list: (projectId: number | string) => [...versionKeys.all, projectId, "list"] as const,
  settings: (projectId: number | string, documentId: number | string) =>
    [...versionKeys.all, projectId, documentId, "settings"] as const,
};
